import { render, staticRenderFns } from "./DeclaracaoEduCampo.vue?vue&type=template&id=e75f0a8e&scoped=true"
import script from "./DeclaracaoEduCampo.vue?vue&type=script&lang=js"
export * from "./DeclaracaoEduCampo.vue?vue&type=script&lang=js"
import style0 from "./DeclaracaoEduCampo.vue?vue&type=style&index=0&id=e75f0a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e75f0a8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
